import {combineReducers} from "@reduxjs/toolkit";
import {authReducer} from '~/features/Auth/authSlice';
import {candidateReducer} from '~/features/Candidates/candidatesSlice';
import {personnelReducer} from '~/features/Personnel/personnelSlice';
import {groupReducer} from '~/features/Personnel/groupSlice';
import {workingDayReducer} from '~/features/WorkingDay/workingDaySlice';
import {customerReducer} from '~/features/Customer/customerSlice';
import {customerGroupReducer} from '~/features/Customer/customerGroupSlice';
import {contractReducer} from '~/features/Contract/contractSlice';
import {revenueReducer} from '~/features/Revenue/revenueSlice';
import {expenseReducer} from '~/features/Expense/expenseSlice';
import {expenseGroupReducer} from '~/features/Expense/expenseGroupSlice';
import {expenseEventReducer} from '~/features/Expense/expenseEventSlice';
import {receiptReducer} from '~/features/Receipt/receiptSlice';
import {receiptGroupReducer} from '~/features/Receipt/receiptGroupSlice';
import {projectReducer} from '~/features/Project/projectSlice';
import {projectTaskReducer} from '~/features/Task/projectTaskSlice';
import {formSabbaticalReducer} from '~/features/Form/formSabbaticalSlice';
import {formSalaryReducer} from '~/features/Form/formSalarySlice';
import {formPaymentReducer} from '~/features/Form/formPaymentSlice';
import {saleEventReducer} from '~/features/Sale/saleEventSlice';
import {saleConsultationReducer} from '~/features/Sale/saleConsultationSlice';
import {saleWorkingReducer} from '~/features/Sale/saleWorkingSlice';
import {saleCommitReducer} from '~/features/Sale/saleCommitSlice';
import {saleCallSourceReducer} from '~/features/Sale/saleCallSourceSlice';
import {uploadWebsiteReducer} from '~/features/Website/uploadWebsiteSlice';
import {createdWebsiteReducer} from '~/features/Website/createdWebsiteSlice';
import {buyServiceReducer} from '~/features/BuyService/buyServiceSlice';
import {payReducer} from '~/features/Pay/paySlice';
import {serviceReducer} from '~/features/Service/serviceSlice';
import {serviceToDoReducer} from '~/features/Service/serviceToDoSlice';
import {extendReducer} from '~/features/Extend/extendSlice';
import {papersReducer} from '~/features/Papers/papersSlice';
import {papersNumberReducer} from '~/features/Papers/papersNumberSlice';
import {papersTypeReducer} from '~/features/Papers/papersTypeSlice';
import {ruleReducer} from '~/features/Rules/RuleSlice';
import {documentReducer} from '~/features/Documents/DocumentSlice';
import {ticketReducer} from '~/features/Ticket/TicketSlice';
import {promotionReducer} from '~/features/Promotion/promotionSlice';
import {hostInfoReducer} from '~/features/HostInfo/HostInfoSlice';
import {requestDemoReducer} from '~/features/RequestDemo/RequestDemoSlice';
import {builderLicenseReducer} from '~/features/BuilderLicense/builderLicenseSlice';
import {cronjobReducer} from '~/features/CronJob/cronjobSlice';

const rootReducer = combineReducers({
	auth        : authReducer,
	candidates  : candidateReducer,
	personnel   : personnelReducer,
	group       : groupReducer,
	workingDay  : workingDayReducer,
	customer    : customerReducer,
	customerGroup : customerGroupReducer,
	contract    : contractReducer,
	revenue    : revenueReducer,
	expense    : expenseReducer,
	expenseGroup    : expenseGroupReducer,
	expenseEvent    : expenseEventReducer,
	receipt    : receiptReducer,
	receiptGroup    : receiptGroupReducer,
	project     : projectReducer,
	projectTask   : projectTaskReducer,
	formSabbatical: formSabbaticalReducer,
	formSalary    : formSalaryReducer,
	formPayment   : formPaymentReducer,
	saleEvent     : saleEventReducer,
	saleConsultation : saleConsultationReducer,
	saleWorking    : saleWorkingReducer,
	saleCommit     : saleCommitReducer,
	saleCallSource : saleCallSourceReducer,
	uploadWebsite  : uploadWebsiteReducer,
	createdWebsite : createdWebsiteReducer,
	buyService     : buyServiceReducer,
	pay   : payReducer,
	service   : serviceReducer,
	serviceToDo   : serviceToDoReducer,
	extend   : extendReducer,
	papers   : papersReducer,
	papersNumber : papersNumberReducer,
	papersType : papersTypeReducer,
	rule : ruleReducer,
	document : documentReducer,
	ticket : ticketReducer,
	promotion : promotionReducer,
	hostInfo : hostInfoReducer,
	requestDemo : requestDemoReducer,
	builderLicense : builderLicenseReducer,
	cronjob : cronjobReducer,
});

export default rootReducer;
